<template>
    <div :class="miniChat ? 'mini-chat-vue' : 'container container-xl container-chat'">
        <div :class="miniChat ? 'mini-chat-vue__wrap' : 'chat-page-wrap'">
            <UserList 
              ref="userListRef"
              @user-id="changeUser" 
              @close-mini-chat="$emit('close-mini-chat')"
              @chat-list="chatsListFun"
              @chat-new="newChatAdd"
              @mute-users="muteUsersFun"
              @is-hide-user-list="isHideUserList = $event"
              @no-conversations="hasNoConversations = $event"
              @mark-all-read="countUnreadConversation = 0"
              @user-mute="({ userId, isMute }) => userMute(userId, isMute, true)"
              :countUnreadConversation="countUnreadConversation"
              :testUrlQuickChat="testUrlQuickChat"
              :isLoadingMessages="isLoadingMessages"
              :language="language"
              :usersListAll="usersListAll"
              :isTablet="tablet"
              :isMobile="mobile"
              :miniChat="miniChat"
              :ifActiveUserInfo="ifActiveUserInfo"
              :isActiveNewMsgConversation="isActiveNewMsgConversation"
              :isActiveConversiation="isActiveConversiation"
              :currentUserUuid="currentUserUuid"/>
            <ChatBody
              ref="chatBodyRef"
              @loading-messages="isLoadingMessages = $event"
              @toggle-user-info="toggleUserInfo"
              @btn-back="btnBackBody"
              @user-mute="({ userId, isMute }) => userMute(userId, isMute)"
              :isHideUserList="isHideUserList"
              :testUrlQuickChat="testUrlQuickChat"
              :isLoadingMessages="isLoadingMessages"
              :isTablet="tablet"
              :isMobile="mobile"
              :ifMiniDesktop="miniDesktop"
              :isDesktop="desktop"
              :language="language"
              :myUser="user"
              :miniChat="miniChat"
              :isShowChatBody="isShowChatBody"
              :isActiveConversiation="isActiveConversiation"
              :currentUserUuid="currentUserUuid"
              :currentUser="currentUser"
              :hasNoConversations="hasNoConversations"/>
            <ModalReportUser :miniChat="miniChat"/>
            <SvgSpriteChat/>
        </div>
    </div>
</template>
  
  <script>
  import UserList from './parts/ChatUserList.vue';
  import ChatBody from './parts/ChatBody.vue';
  import ModalReportUser from './parts/ModalReportUser.vue';
  import SvgSpriteChat from './parts/SvgSpriteChat.vue';
  export default {
    components: {
        UserList,
        ChatBody,
        ModalReportUser,
        SvgSpriteChat
    },
    props: {
        miniChat: {
          type: Boolean,
          default: false,
        },
        usersListAll: {
          type: Array,
          default: () => []
        },
        isActiveConversiationProp: {
          type: Boolean,
          default: false,
        },
        // Live unread counter from the header socket (mini chat only).
        // The mini chat is re-created on every open, so the page-load value may be stale.
        unreadCountProp: {
          type: Number,
          default: null,
        },
    },
    data() {
      return {
        user: window?.common.user,
        language: window.common.language.code2 || 'en',
        isActiveConversiation: false,
        ifActiveUserInfo: false,
        chatsList: [],
        hasNoConversations: false,
        isHideUserList: false,
        currentUser: null,
        currentUserUuid: '',
        mobile: false,
        tablet: false,
        miniDesktop: false,
        desktop: false,
        isShowChatBody: true,
        lastTimemarkList: null,
        firstTimemarkMsg: null,
        isActiveNewMsgConversation: false,
        countUnreadConversation: this.unreadCountProp ?? window.header?.chat?.count_unread_conversations ?? 0,
        socket: null,
        isLoadingMessages: false,
        testUrlQuickChat: window.header?.chat?.api_host
      };
    },
    mounted() {
      const uuid = new URLSearchParams(window.location.search).get('uuid');
      const user_id = new URLSearchParams(window.location.search).get('user_id');
      
      this.checkWindowSize();
      window.handleIncomingMessage = this.handleIncomingMessage;
      window.handleCountMessage = this.handleCountMessage;
      window.handleAddConversation = this.handleAddConversation;
      if(this.usersListAll.length > 9 && this.countUnreadConversation === 0 && this.miniChat) {
        if (this.$refs.userListRef) {
          this.$refs.userListRef.getConversations('pinned');
        }
      } else  if (this.$refs.userListRef) {
        this.$refs.userListRef.getConversations('firstLoad');
      }
      if (!this.miniChat) {
        document.body.classList.add('nolauncher');
      } else {
        this.isShowChatBody = false
      }
      if (uuid) {
        this.isActiveConversiation = true;
        this.currentUserUuid = uuid;
        if(this.tablet) {
          this.isShowChatBody = true
        }
      }
      if(!!user_id && !!this.$refs.userListRef) {
        this.$refs.userListRef.getUsersInfo('all', [+user_id]);
      }
      if(this.isActiveConversiationProp) {
        this.isActiveConversiation = true;
        this.isShowChatBody = true;
        
        if (this.chatsList.some(user => user.uuid === this.currentUserUuid)) {
          this.isActiveConversiation = false;
          this.currentUser = this.chatsList.find(user => user.uuid === this.currentUserUuid);
        }
      }
      if(this.tablet && !uuid) {
        this.isShowChatBody = false
      }
      const viewportMeta = document.querySelector('meta[name="viewport"]');
      if (viewportMeta) {
        viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0, viewport-fit=cover');
      } else {
        const meta = document.createElement('meta');
        meta.name = 'viewport';
        meta.content = 'width=device-width, initial-scale=1.0, viewport-fit=cover';
        document.head.appendChild(meta);
      }
    },
    watch: {
      unreadCountProp(count) {
        if (count !== null) this.countUnreadConversation = count;
      },
      isActiveConversiationProp(bool) {
        this.isActiveConversiation = bool;
        if(bool) {
          this.isShowChatBody = true
        }
      },
      chatsList() {
        if (this.isActiveConversiation && this.currentUserUuid) {
          this.currentUser = this.chatsList.find(user => user.uuid === this.currentUserUuid);
        }
      }
    },
    beforeUnmount() {
      if (window.handleIncomingMessage === this.handleIncomingMessage) {
          delete window.handleIncomingMessage;
      }
      if (window.handleCountMessage === this.handleCountMessage) {
          delete window.handleCountMessage;
      }
      if (window.handleAddConversation === this.handleAddConversation) {
          delete window.handleAddConversation;
      }
    },
    methods: {
      btnBackBody(){
        if(this.isHideUserList) {
          if (window.history.length > 1) {
            window.history.back();
          } else if (document.referrer) {
            window.location.href = document.referrer;
          } else {
            window.location.href = window.location.origin;
          }
        } else {
          this.currentUser = null;
          this.currentUserUuid = '';
          this.isShowChatBody = false;
        }
      },
      toggleUserInfo(bool) {
        if (this.miniDesktop && !this.mobile) {
          this.ifActiveUserInfo = bool;
        }
      },
      newChatAdd(chat) {
        this.chatsList.push(chat)
        if (!this.currentUser || this.currentUser.uuid !== this.currentUserUuid) {
          this.currentUser = this.chatsList.find(user => user.uuid === this.currentUserUuid);
        }
      },
      chatsListFun(list) {
        const merged = new Map();
        this.chatsList.forEach(chat => merged.set(chat.uuid, chat));
        list.forEach(chat => merged.set(chat.uuid, chat));
        this.chatsList = Array.from(merged.values());
        if (!this.currentUser || this.currentUser.uuid !== this.currentUserUuid) {
          this.currentUser = this.chatsList.find(user => user.uuid === this.currentUserUuid);
        }
        if(this.chatsList.length === 1) {
          this.isActiveConversiation = true;
          this.currentUser = this.chatsList[0];
          this.currentUserUuid = this.currentUser.uuid;
          this.changeUser(this.currentUserUuid)
          if(this.miniChat) this.isShowChatBody = true;
          if (this.$refs.userListRef) {
            this.$refs.userListRef.markRead(this.currentUserUuid);
          }
        }
      },
      changeUser(uuid) {
        this.isActiveConversiation = false;
        this.currentUser = this.chatsList.find(user => user.uuid === uuid);
        this.currentUserUuid = this.currentUser?.uuid ? this.currentUser.uuid : uuid;
        this.$emit('change-user');
        if (this.miniChat || this.tablet) {
          this.isShowChatBody = true;
        }
        if(!this.miniChat) {
          //let isActiveInfo = new URLSearchParams(window.location.search).get('order_id')
          if(this.$refs.chatBodyRef) {
            this.$refs.chatBodyRef.toggleUserInfo(false, true);
          }

          const url = new URL(window.location);
          url.searchParams.delete('order_id');
          
          if (uuid) {
            url.searchParams.set('uuid', uuid);
          } else {
            url.searchParams.delete('uuid');
          }
          if (this.currentUser?.user?.id) {
            url.searchParams.set('user_id', this.currentUser.user.id);
          } else {
            url.searchParams.delete('user_id');
          }

          window.history.replaceState({}, '', url);
        }
      },
      userMute(userId, isMute, isFromChatList = false) {
        if(isFromChatList) {
          const user = this.chatsList.find(user => user.uuid === userId);
          if (user) {
            user.is_mute = isMute;
          }
        }
        if(this.currentUser?.uuid === userId) {
          this.currentUser.is_mute = isMute;
        }
        
        if (this.$refs.userListRef) {
          this.$refs.userListRef.userMute(userId, isMute, false);
        }
      },
      muteUsersFun(bool) {
        this.$emit('mute-users', bool);
      },
      handleAddConversation([uuid, userId, ifNew]) {
        if(this.currentUserUuid === uuid) return
        this.currentUserUuid = uuid;

        if (this.chatsList.some(user => user.uuid === uuid)) {
          this.isActiveConversiation = false;
          this.currentUser = this.chatsList.find(user => user.uuid === uuid);
        } else if (this.$refs.userListRef) {
          if (ifNew) {
            this.$refs.userListRef.getConversations('all');
          } else {
            this.$refs.userListRef.getUsersInfo('all', [userId]);
          }
        }
      },
      handleIncomingMessage(socketData, isUpdate = false) {
        if (this.$refs.userListRef) {
          this.$refs.userListRef.handleChatMessage(socketData, isUpdate);
        }
        if(this.$refs.chatBodyRef) {
          this.$refs.chatBodyRef.handleChatMessage(socketData, isUpdate);
        }
      },
      handleCountMessage(data) {
        this.countUnreadConversation = data.count;

        this.isActiveNewMsgConversation = data.conversationIds.some(item => item.uuid === this.currentUserUuid);
        if (this.isActiveNewMsgConversation) {
          if (this.$refs.userListRef) {
            this.$refs.userListRef.markRead(this.currentUserUuid);
          }
        }
      },
      checkWindowSize() {
        this.mobile = window.innerWidth < 767;
        this.tablet = window.innerWidth < 1023;
        this.miniDesktop = window.innerWidth < 1279;
        this.desktop = window.innerWidth < 1439;
      },
    }
  };
  </script>
  
  <style lang="scss">
  @use './style/tokens';
  @use './style/forms';
  .doubleclick{
    display: none !important;
  }
  .page-wrap__default{
    //padding-top: 0 !important;
  }
  .nolauncher {
    #support-chat,
    #launcher {
      @media screen and (max-width: 767px) {
        display: none;
      }
    }
  }
  .styled-back{
    @media only screen and (max-width: 1023px) {
      display: none !important;
    }
  }
  // Full-bleed chat page under the site header (design: edge to edge, no card)
  .page-wrap.chat-page{
    padding: 0 !important;
  }
  .container-chat{
    max-width: none !important;
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .chat-page-wrap{
    display: flex;
    overflow: hidden;
    margin: 0;
    width: 100%;
    height: calc(100vh - 62px);
    background: var(--wc-surface);
    border-top: 1px solid var(--wc-border);
    font-family: var(--wc-font);
    color: var(--wc-text);
    @media only screen and (max-width: 1023px) {
      height: calc(100vh - 70px);
      position: relative;
      //padding-top: 70px;
    }
    @media only screen and (max-width: 767px) {
      max-height: calc(100dvh - 44px);
      height: calc(100dvh - 44px);
      //padding-top: 44px;
    }
  }
  // Mini chat composer is a flat bar with a top divider (design: compact composer)
  .mini-chat-vue .mini-chat-vue__wrap{
    .chat-body__bottom{
      --wc-composer-x: 0px;
      padding: 0;
      background: var(--wc-surface);
      border-top: 1px solid var(--wc-border);
      &::before{
        bottom: 0;
        height: 100%;
        border: 0;
        border-radius: 0;
        box-shadow: none;
      }
    }
    .chat-body__bottom-wrap{
      padding: 8px;
      border: 0;
      border-radius: 0;
      box-shadow: none;
    }
    // keep the emoji panel 8px inside the mini chat edge
    .chat-body-form-btn__emoji-wrap{
      right: -40px;
    }
  }
  .mini-chat-vue{
    position: relative;
    &.modal-open{
      z-index: 1001;
      position: relative;
    }
    &__wrap{
      position: absolute;
      right: -110px;
      top: 50px;
      bottom: unset;
      min-width: 380px;
      max-width: 380px;
      width: 100%;
      z-index: 101;
      max-height: 775px;
      display: flex;
      border: 1px solid var(--wc-border);
      box-shadow: 0 16px 48px rgba(15, 23, 41, 0.2);
      border-radius: 16px;
      background: var(--wc-surface);
      color: var(--wc-text);
      font-family: var(--wc-font);
      overflow: hidden;
      @media only screen and (max-width: 1640px) {
        max-height: 600px;
        max-width: 350px;
      }
    }
  }
  </style>